import { DisplayMode as DisplayModeLibType } from '@technology/web3d-plugin-markup';

export type SlopeAngleFormat = 'ratio' | 'percentage' | 'degrees';

/**
 * Local runtime redefinition of `DisplayMode`.
 * The original enum in `@technology/web3d-plugin-markup` is declared as a `const enum`,
 * which is erased during compilation and therefore unavailable at runtime.
 * This replacement provides an equivalent runtime object with proper type safety.
 */
export const DisplayMode = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Slope: 0,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  VerticalHorizontal: 1,
} as const satisfies Record<
  keyof typeof DisplayModeLibType,
  DisplayModeLibType
>;
export type SlopeDisplayMode = (typeof DisplayMode)[keyof typeof DisplayMode];

export interface SlopeMeasurementSettings {
  displayMode?: SlopeDisplayMode;
  format?: SlopeAngleFormat;
}
